"use strict";

module.exports = require("./is-implemented")()
	? require("ext/global-this").Symbol
	: require("./polyfill");



//////////////////
// WEBPACK FOOTER
// ./node_modules/es6-symbol/index.js
// module id = 211
// module chunks = 0